export default "__VITE_ASSET__ClHHEtaa__"